import { styled } from '@mui/material/styles';

export const RoomAssignmentsContainer = styled('div')({
  maxWidth: 1100,
  width: '100%',
  margin: '0 auto',
});

/** Separates one checklist from the next (matches realm Doc category spacing). */
export const ChecklistRoot = styled('div')(({ theme }) => ({
  paddingTop: theme.spacing(1),
  paddingBottom: theme.spacing(1),
}));
